import VocHeaderMenu from "./src/header-menu"

/* istanbul ignore next */
VocHeaderMenu.install = function (Vue) {
  Vue.component(VocHeaderMenu.name, VocHeaderMenu)
}

export default VocHeaderMenu
